import { wrapApiCall } from '@/lib/axios'
import type { ReportLang } from '@/utils/helper/reportLang'
import type { AxiosInstance } from 'axios'
import {
  MemberFeedbackFilter,
  MemberFeedbackListInput,
  MemberFeedbackPage,
  MemberFeedbackSummary,
} from './model'

export const MemberFeedbackService = (client: AxiosInstance) => {
  return {
    async list(input: MemberFeedbackListInput): Promise<MemberFeedbackPage> {
      const { data } = await wrapApiCall(() =>
        client.get<MemberFeedbackPage>('/member-feedback', { params: input })
      )
      return data
    },

    async summary(input: MemberFeedbackFilter): Promise<MemberFeedbackSummary> {
      const { data } = await wrapApiCall(() =>
        client.get<MemberFeedbackSummary>('/member-feedback/summary', { params: input })
      )
      return data
    },

    /** One Excel workbook — summary, per-topic breakdowns and the raw rows. */
    async exportExcel(input: MemberFeedbackFilter & { lang: ReportLang }): Promise<Blob> {
      const { data } = await wrapApiCall(() =>
        client.get<Blob>('/member-feedback/export', {
          params: input,
          responseType: 'blob',
          headers: {
            Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          },
        })
      )
      return data
    },
  }
}
